module.exports = __webpack_public_path__ + "static/media/bg.2810fe6b.png";